import '@/components/common/css/course/details_module.css';
import '@/components/common/css/course/details_onetoone.css';
import DetailOrder from '@/components/courseCenter/detail/public/order.vue';
import Front from '@/components/courseCenter/detail/public/Front.vue';
import TalkQq from '@/components/courseCenter/detail/public/TalkQq.vue';
import CourseDialog from '@/components/courseCenter/detail/public/CourseDialog.vue';
import {mapState} from 'vuex';
import CityCodeData from '@/common/libs/CityCodeData';
import utils from '../../../../common/libs/utils.js';
import SubscribeCourse from "@/common/libs/SubscribeCourse";
import groupWork from '../../public/groupWork/grouWork.vue'

export default{
  name: 'OneDetail',
  components: {
    DetailOrder,
    Front,
    TalkQq,
    CourseDialog,
    groupWork
  },
  data(){
    return {
      routeFrom: this.$route.query.routeName,
      isTschool: this.$route.query.city != 'qt'
    }
  },
  asyncData({store, route}){
    //课程详情页是会分享出去的，必须获取本地的phone，不应该从url中获取
    let city = CityCodeData.getCityByShort(route.params.city);
    let location = store.state.home.location;
    let mine = store.state.mine.state;
    let query = route.query;
    let params = route.params;
    if (params.courseId&&/^[0-9a-zA-Z]+$/g.test(params.courseId)){
      return store.dispatch('getCourseInfo', {city, location, query, mine, params});
    }
  },
  computed: {
    ...mapState({
      city: state => state.home.city,
      content: state => state.course.courseInfo
    }),
    isOnlineGroup() {
      // 是否是在线8人班
      return this.content.type == 14 || this.content.type == 15 || this.content.type == 16
    },
    showNewDetail() {
      return this.content.is_show_new_gw_content === 1
    }
  },
  watch: {
    content: {
      handler: function(newVal, oldVal){
        document.title = `${newVal.title  }_${  this.city.city_name  }学而思爱智康`;
      },
      deep: true
    }
  },
  methods: {
    goMap(){
      this.$router.push({name: 'map', query: {
        school_name: this.content.school_info.name,
        address: this.content.school_info.address,
        lat: this.content.school_info.lat,
        lng: this.content.school_info.lng
      }});
    },
    order(){
      if (this.content.sub_status){
        return;
      }
      let school_id = this.content.school_info ? this.content.school_info.id : '';
      let school_name = this.content.school_info ? this.content.school_info.name : '';
      let subType = this.content.sub_type.split('_');
      let route = this.$route.query;
      let stater = this.$store.state;
      let obj = {
        'page_view': this.$route.query.index ? '首页推荐' : '选课中心',
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'class_type': this.content.extra_type_2 + this.content.extra_type_1,
        'course_type': this.content.extra_type_3,
        'course_grade': this.content.grade_msg,
        'course_subject': this.content.subject_msg,
        'course_cycle_time': this.content.course_begin_datetime,
        'course_location': school_name,
        'course_character': this.content.feature_msg,
        'course_name': this.content.title
      };
      utils.bury('yd_izhikang_coursedetail_order_click', obj);
      
      let token = utils.cookie.get('token')|| '';
      if (token && (this.routeFrom == 'qtGroupForOnline' || this.routeFrom == 'qtOnline')) {
        let query = {
          name: this.routeFrom,
          course_type: this.$route.query.course_type
        }
        SubscribeCourse.call(this, this.content, query)
        return
      }

      this.$router.push({name: 'order', query: {
        course_id: this.content.course_id || this.content.id,
        grade: this.content.grade || '',
        type: this.content.type,
        sub_type: this.content.sub_type,
        school_id,
        school_name,
        course_type: route.course_type,
        name: route.routeName,
        category: route.category,
        teaching_mode: subType[1]
      }});
    },
    showCourse(){
      this.showCourseDialog();
    },
    renderLubanDetail(){
      this.$store.commit('isShowLoading', true)
      if (this.content.is_show_new_gw_content === 1 && this.content.gw_content) {
        let env = this.getDir()
        let temp = utils.formatDate(new Date(), 'yyyyMMdd');
          utils.loadStyle(`https://static1.izhikang.com/webresource/${env}/engine-assets/1.0.0/engine.css?timestamp=${temp}`);
        var newContent= this.content.gw_content.replace(/https:\/\/static4.izhikang.com[^"]+\.png/gi, (match, capture) => {
            var imgUrl = match;
            if (match.indexOf('imageMogr') === -1){
               imgUrl = utils.imageMogr2(match, {q: 90 });
            }
         　　return `${imgUrl}`;
        });
          new Function(newContent)()
          utils.loadScript(`https://static1.izhikang.com/webresource/${env}/engine-assets/1.0.0/engine.umd.min.js?timestamp=${temp}`, () => {
            engine && engine.default.vueInit("#h5MainPage")
            this.$store.commit('isShowLoading', false)
          });
      } else {
        this.$store.commit('isShowLoading', false)
      }
    },
    getDir() {
      let dir = '';
      switch (process.env.NODE_ENV) {
        case 'beta' : dir = 'luban-engine-beta'; break;
        case 'pre' : dir = 'luban-engine-pre'; break;
        case 'production' : dir = 'luban-engine-prod'; break;
        default: dir = 'luban-engine-beta';
          break
      }
      return dir;
    }
  },
  mounted(){
    this.$store.commit('isShowHeader', {isShowHeader: false});
    this.$store.commit('isShowFooter', {isShowFooter: false});
    
    if (this.content.is_show_new_gw_content === 1) {
      this.renderLubanDetail();
    }

    let stater = this.$store.state;
    let content = this.content;
    let school_name = content.school_info ? content.school_info.name : '';
    console.log('-----------------content:', content);
    if (this.$route.query.index >= 0){
      let obj = {
        'locate_city': stater.home.city.city_name,
        'user_grade': stater.course.grade.name || '三年级',
        'course_type': content.extra_type_3,
        'course_grade': content.grade_msg || '',
        'course_subject': content.subject_msg || '',
        'course_semester': content.course_begin_datetime || '',
        'course_cycle_time': content.course_begin_timestamp || '',
        'course_location': school_name,
        'course_character': content.type_msg,
        'course_name': content.title,
        'recom_id': this.$route.query.index
      }

      utils.bury('yd_izhikang_headpage_detailpage_browse', obj);
      return;
    }

    let obj = {
      'locate_city': stater.home.city.city_name,
      'user_grade': stater.course.grade.name || '三年级',
      'class_type': content.extra_type_2 + content.extra_type_1,
      'course_type': content.extra_type_3,
      'course_grade': content.grade_msg || '',
      'course_subject': content.subject_msg || '',
      'course_semester': content.course_begin_datetime || '',
      'course_cycle_time': content.course_begin_timestam || '',
      'course_location': school_name,
      'course_character': content.type_msg,
      'course_name': content.title
    }

    utils.bury('yd_izhikang_center_detailpage_browse', obj);
  },
  beforeDestroy(){
    let env = this.getDir()
    let temp = utils.formatDate(new Date(), 'yyyyMMdd');
    utils.unloadScript(`https://static1.izhikang.com/webresource/${env}/engine-assets/engine.umd.min.js?timestamp=${temp}`);
  }
}





// WEBPACK FOOTER //
// ./src/components/courseCenter/detail/course/CourseDetailVm.js